import React, { useMemo } from 'react';

import { Flex, Table, Typography, type TableColumnsType } from 'antd';
import { OcurrenceData } from 'src/interfaces/entities/occurence-data';

export default function OccurrenceTable(
	{
		occurrence_data,
		loading,
	}: {
		occurrence_data?: OcurrenceData,
		loading?: boolean
	}
) {
	const data = useMemo(() => {
		if (!occurrence_data) return [];
		return occurrence_data.occurence.affectedRows.result;
	}, [ occurrence_data, ]);

	const columns = useMemo<TableColumnsType<object>>(() => {
		if (!occurrence_data || !occurrence_data.occurence.affectedRows.result[0]) return [];

		const fields = Object.keys(occurrence_data.occurence.affectedRows.result[0]);
		return fields.map(field => ({
			dataIndex: field,
			title: field,
			key: field,
		}));
	}, [ occurrence_data, ]);

	return (
		<>
			<Flex gap={8}>
				<Typography.Title level={5}>
Retorno da ocorrência:
				</Typography.Title>
			</Flex>
			<Table<object>
				columns={columns}
				dataSource={data}
				rowKey={(_, index) => String(index)}
				loading={loading}
				size="small"
				pagination={false}
				scroll={{ y: 300, }}
			/>
		</>
	);
}
